import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"pa-1",staticStyle:{"background":"none"},attrs:{"flat":""}},[_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.dashboard.title))]),_c('h3',[_vm._v(_vm._s(_vm.dashboard.description))]),_c(VRow,_vm._l((_vm.dCharts),function(chart){return _c(VCol,{attrs:{"cols":chart.value}},[_c('chart-component',{attrs:{"chart":chart}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }